import React, { Component } from "react"
import { Context } from "@shopify/app-bridge-react"
import { Pos, Features, Cart, Group, Toast } from "@shopify/app-bridge/actions"
import { defineMessages, FormattedMessage, FormattedNumber, injectIntl } from "react-intl"
import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import PaymentTermSelect from "../../payment-term/locationselect.component.jsx"
import moment from "moment"
import { SingleDatePicker } from "react-dates"
import "react-toggle/style.css"
import Toggle from "react-toggle"
import DeprecatedCustomerEmailSelect from "../../customer/emailselection.component.jsx"
import LoadingSpinner from "../../common/spinner/loading.component.jsx"

const messages = defineMessages({
    po_number_placeholder: {
        id: "embed.ls_retail.new_invoice_modal.po_number_placeholder",
        defaultMessage: "i.e: PO-1234"
    },
    error_creating_document: {
        id: "invoice.pos.error_document",
        defaultMessage: "Error creating your document. Please contact support."
    },
    success: {
        id: "invoice.pos.success",
        defaultMessage: "Success!"
    },
    quotes: {
        id: "invoice.pos.quote_label",
        defaultMessage: "quote"
    },
    invoices: {
        id: "invoice.pos.invoice_label",
        defaultMessage: "invoice"
    }
})
class NewPayableDocument extends Component {
    constructor(props, context) {
        super(props, context)

        const dueDate = moment()
        this.state = {
            loading: true,
            paymentTermId: "",
            focused: false,
            dueDate: dueDate,
            hasPaymentTerms: false,
            isSuccess: false,
            sendEmail: false,
            poNumber: "",
            toEmail: this.props.shopifyCustomer.email ? [this.props.shopifyCustomer.email] : "",
            toEmailError: false,
            userInfo: "",
            locationInfo: "",
            documentId: ""
        }

        NewPayableDocument.contextType = Context
        this.loadPaymentTerm = this.loadPaymentTerm.bind(this)
        this.handleFormChange = this.handleFormChange.bind(this)
        this.submit = this.submit.bind(this)
        this.closePOSapp = this.closePOSapp.bind(this)
        this.renderDocumentType = this.renderDocumentType.bind(this)
    }

    componentDidMount() {
        if (this.props.documentType === "invoices") {
            AppContext.getApiClient()
                .get("/payment-terms")
                .then(res => {
                    this.setState({
                        hasPaymentTerms: res.data.length > 0
                    })
                    const term = res.data.find(t => t.attributes.isDefault)

                    if (term) {
                        this.loadPaymentTerm(term.id)
                    }
                })
        } else {
            this.setState({
                loading: false
            })
        }

        const shopifyApp = this.context
        shopifyApp.getState("pos").then(posInfo => {
            this.setState({
                userInfo: posInfo.user,
                locationInfo: posInfo.location
            })
        })
    }

    renderDocumentType() {
        switch (this.props.documentType) {
        case "invoices":
            return this.props.intl.formatMessage(messages["invoices"])
        default:
            return this.props.intl.formatMessage(messages["quotes"])
        }
    }

    closePOSapp() {
        const shopifyApp = this.context

        const cart = Cart.create(shopifyApp)
        cart.dispatch(Cart.Action.CLEAR)

        const pos = Pos.create(shopifyApp)
        pos.dispatch(Pos.Action.CLOSE)
    }

    loadPaymentTerm(paymentTermId) {
        if (!paymentTermId) {
            this.setState({
                loading: false,
                paymentTermId: ""
            })
            return
        }

        AppContext.getApiClient()
            .post("/payment-terms/" + paymentTermId + "/evaluate", {
                issuedDate: new Date().toISOString()
            })
            .then(res => {
                this.setState({
                    paymentTermId: paymentTermId,
                    dueDate: moment(res.attributes.dueDate),
                    loading: false
                })
            })
    }

    handleFormChange(event) {
        const target = event.target
        this.setState({
            [target.name]: target.value
        })
    }

    submit(event) {
        event.preventDefault()
        const shopifyApp = this.context
        const { id, email } = this.state.userInfo

        let cart = this.props.cartInfo
        cart["sellerId"] = id
        cart["sellerEmail"] = email
        cart["locationId"] = this.state.locationInfo.id

        const toastOptions = {
            message: this.props.intl.formatMessage(messages["error_creating_document"]),
            duration: 10000,
            isError: true
        }

        const toastError = Toast.create(shopifyApp, toastOptions)

        AppContext.getApiClient()
            .post(`/${this.props.documentType}/single-import`, {
                externalId: "",
                integrationKey: "shopify",
                capturePayment: false,
                applyPayments: false,
                invoice: {
                    paymentTermId: this.state.paymentTermId,
                    poNumber: this.state.poNumber,
                    dueDate: this.state.dueDate
                },
                externalInvoice: cart,
                contactEmail: this.state.sendEmail ? this.state.toEmail[0] : "",
                sendEmail: this.state.sendEmail
            })
            .then(res => {
                if (res.error) {
                    toastError.dispatch(Toast.Action.SHOW)
                } else {
                    this.setState({ isSuccess: true, documentId: res.attributes.identifier })
                }
            })
    }

    renderSubmitButton() {
        switch (this.props.documentType) {
        case "quotes":
            return (
                <button type="submit" className="btn btn-primary btn-lg btn-block mt-4" onClick={this.submit}>
                    <FormattedMessage id="common.quote.modal.confirm_btn" defaultMessage="Create quote" />
                </button>
            )
        case "invoices":
        default:
            return (
                <button type="submit" className="btn btn-primary btn-lg btn-block mt-4" onClick={this.submit}>
                    <FormattedMessage id="common.invoice.modal.confirm_btn" defaultMessage="Create invoice" />
                </button>
            )
        }
    }

    render() {
        const { firstName, lastName } = this.props.shopifyCustomer

        if (this.state.loading) {
            return <LoadingSpinner marginTop="20px" />
        }
        return (
            <div style={{ marginTop: "150px" }}>
                {this.state.isSuccess ? (
                    <div>
                        <h4 className="alert-heading">
                            <i className={"fa fa-check"}></i>
                            {this.props.intl.formatMessage(messages["success"])}
                        </h4>
                        <div>
                            <div style={{ marginBottom: "150px" }}>
                                <FormattedMessage
                                    id="pos.document.creation.success"
                                    defaultMessage="Your {docType} ({docId}) was created. Select new items to create a new document."
                                    values={{
                                        docId: this.state.documentId,
                                        docType: this.renderDocumentType()
                                    }}
                                />
                            </div>
                            <button className="btn btn-primary btn-lg btn-block mt-4" onClick={this.closePOSapp}>
                                <FormattedMessage id="common.quote.modal.ok_btn" defaultMessage="Close" />
                            </button>
                        </div>
                    </div>
                ) : (
                    <div>
                        <div className="form-group row mb-1">
                            <label className="col-12 col-md-3  col-form-label custom-form-label pb-2 text-body text-right">
                                <FormattedMessage id="embed.ls_retail.new_invoice_modal.contact_label" defaultMessage="Contact" />
                            </label>
                            <div className="col-12 col-md-2 text-left pt-2">
                                <div className={"mb-2"}>{firstName + " " + lastName}</div>
                            </div>
                        </div>
                        {this.state.hasPaymentTerms && (
                            <div className="form-group row mb-1">
                                <label className="col-12 col-md-3  col-form-label custom-form-label pb-2 text-body text-right">
                                    <FormattedMessage
                                        id="common.invoice.modal.payment_terms_label"
                                        defaultMessage="Payment term"
                                    />
                                </label>
                                <div className="col-12 col-md-9">
                                    <div className={"mb-2"}>
                                        <PaymentTermSelect
                                            className="from-control-large"
                                            value={this.state.paymentTermId}
                                            onChange={this.loadPaymentTerm}
                                            clearable={false}
                                            searchable={false}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}

                        {["invoices"].includes(this.props.documentType) && (
                            <div className="form-group row mb-1">
                                <label
                                    htmlFor="dueDate"
                                    className="col-12 col-md-3  col-form-label custom-form-label pb-2 text-body text-right"
                                >
                                    <FormattedMessage id="common.invoice.modal.due_date_label" defaultMessage="Due date" />
                                </label>
                                <div className="col-12 col-md-9">
                                    <div className={"mb-2"}>
                                        <SingleDatePicker
                                            small
                                            block
                                            style
                                            displayFormat="LL"
                                            isOutsideRange={() => false}
                                            focused={this.state.focused}
                                            onDateChange={date => {
                                                this.setState({
                                                    dueDate: date
                                                })
                                            }}
                                            onFocusChange={({ focused }) => this.setState({ focused })}
                                            date={this.state.dueDate}
                                            numberOfMonths={1}
                                            id={"dueDate"}
                                            className="form-control"
                                        />
                                    </div>
                                </div>
                            </div>
                        )}
                        <div className="form-group row mb-1">
                            <label
                                htmlFor={"poNumber"}
                                className="col-12 col-md-3  col-form-label custom-form-label pb-2 text-body text-right"
                            >
                                <FormattedMessage
                                    id="embed.ls_retail.new_invoice_modal.po_number_label"
                                    defaultMessage="PO Number"
                                />
                            </label>
                            <div className="col-12 col-md-9">
                                <div className={"mb-2"}>
                                    <input
                                        value={this.state.poNumber}
                                        onChange={this.handleFormChange}
                                        name={"poNumber"}
                                        id={"poNumber"}
                                        type="text"
                                        className="form-control"
                                        placeholder={this.props.intl.formatMessage(messages["po_number_placeholder"])}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="form-group row mb-1">
                            <label
                                className="col-12 col-md-3  col-form-label custom-form-label pb-2 text-body text-right"
                                htmlFor="sendEmail"
                            >
                                <FormattedMessage
                                    id="bulk.operations.account_statements.send_email"
                                    defaultMessage="Send email"
                                />
                            </label>
                            <div className="col-12 col-md-1">
                                <div className={"pt-1 mb-2"}>
                                    <Toggle
                                        defaultChecked={this.state.sendEmail}
                                        icons={false}
                                        onChange={() =>
                                            this.state.sendEmail
                                                ? this.setState({
                                                    sendEmail: false
                                                })
                                                : this.setState({
                                                    sendEmail: true
                                                })
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                        {this.state.sendEmail && (
                            <div className="form-group row mb-1">
                                <label
                                    className="col-12 col-md-3  col-form-label custom-form-label pb-2 text-body text-right"
                                    htmlFor="sendEmail"
                                >
                                    <FormattedMessage id="common.send_email.modal.to_label" defaultMessage="To" />
                                </label>
                                <div className="col-12 col-md-9 text-center">
                                    <div className={"mb-2"}>
                                        <DeprecatedCustomerEmailSelect
                                            name="toEmail"
                                            value={this.state.toEmail}
                                            onChange={(val, error) => {
                                                this.setState({
                                                    toEmail: val,
                                                    toEmailError: error
                                                })
                                            }}
                                            id="toEmail"
                                            type="text"
                                            multi={false}
                                            className="form-control"
                                        />
                                    </div>
                                </div>
                            </div>
                        )}
                        {this.renderSubmitButton()}
                    </div>
                )}
            </div>
        )
    }
}

export default injectIntl(NewPayableDocument)



// WEBPACK FOOTER //
// ./src/embed/shopify/newpayabledocument.component.jsx